import { ref } from 'vue';

export type UploadMode = 'upload' | 'url' | undefined;

export function useUploadModeSelection() {
  const uploadMode = ref<UploadMode>(undefined);
  const hasSelectedInitialMode = ref(false);
  const pendingMode = ref<UploadMode>(undefined);

  const shouldConfirmModeChange = (
    newMode: UploadMode,
    hasFiles: boolean,
    hasValidUrls: boolean
  ): boolean => {
    if (!hasSelectedInitialMode.value || (!hasFiles && !hasValidUrls)) {
      return false;
    }
    return newMode !== uploadMode.value;
  };

  const setInitialMode = (mode: UploadMode) => {
    uploadMode.value = mode;
    hasSelectedInitialMode.value = true;
  };

  const setPendingMode = (mode: UploadMode) => {
    pendingMode.value = mode;
  };

  const confirmModeChange = () => {
    if (pendingMode.value !== undefined) {
      uploadMode.value = pendingMode.value;
      pendingMode.value = undefined;
      return true;
    }
    return false;
  };

  const cancelModeChange = () => {
    pendingMode.value = undefined;
  };

  const resetModeSelection = () => {
    uploadMode.value = undefined;
    hasSelectedInitialMode.value = false;
    pendingMode.value = undefined;
  };

  return {
    uploadMode,
    hasSelectedInitialMode,
    pendingMode,
    shouldConfirmModeChange,
    setInitialMode,
    setPendingMode,
    confirmModeChange,
    cancelModeChange,
    resetModeSelection,
  };
}
